import { Box, Button, Container, Grid, Typography } from '@material-ui/core';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';

import Background from '../styled/background';

const STORE_QUERY = graphql`
  query storeQuery {
    contentfulTienda {
      imagen {
        fluid(quality: 90, maxWidth: 2000) {
          srcWebp
          srcSetWebp
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  text: {
    color: 'white',
    fontWeight: 300,
    textTransform: 'uppercase',
    '& span': {
      color: theme.palette.secondary.main,
    },

    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
}));

const Store = () => {
  const {
    contentfulTienda: { imagen },
  } = useStaticQuery(STORE_QUERY);
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: false,
  });

  /* eslint-disable-next-line */
  const [refText: ref, inViewText: inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
  });

  const variants = {
    visibleContainer: { opacity: 1, scale: 1, x: 0 },
    hiddenContainer: {
      opacity: 0,
      scale: 1,
      x: -200,
    },
    visibleText: { y: 0 },
    hiddenText: { y: 400 },
  };

  return (
    <motion.div
      animate={inView ? 'visibleContainer' : 'hiddenContainer'}
      ref={ref}
      variants={variants}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <Background image={imagen.fluid.srcWebp}>
        <Container>
          <Grid container spacing={3} justifyContent="flex-end">
            <Grid item xs={12} lg={6} md={8}>
              <motion.div
                animate={inViewText ? 'visibleText' : 'hiddenText'}
                variants={variants}
                transition={{ duration: 1, ease: 'easeOut' }}
                ref={refText}
              >
                <Box mt={10}>
                  <Typography
                    paragraph
                    align="right"
                    className={classes.text}
                    variant="h2"
                  >
                    <strong>Tienda</strong>&nbsp;Exclusiva<span>&reg;</span>
                  </Typography>

                  <Button
                    onClick={() => navigate('/search#more')}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Conócela
                  </Button>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </Container>
      </Background>
    </motion.div>
  );
};

export default Store;
